import React, { useEffect } from 'react'
import { isAmwellTheme } from '../lib/util'

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light'
}

const CLASSNAMES_TO_REMOVE = {
  [THEMES.LIGHT]: 'dark',
  [THEMES.DARK]: 'light'
}

const CLASSNAMES_TO_ADD = {
  [THEMES.LIGHT]: 'light',
  [THEMES.DARK]: 'dark'
}

const SukiContext = React.createContext()

const SukiProvider = (props) => {
  const initialTheme = isAmwellTheme() ? THEMES.DARK : THEMES.LIGHT
  const [theme, setTheme] = React.useState(initialTheme)

  useEffect(() => {
    document.body.classList.remove(CLASSNAMES_TO_REMOVE[theme])
    document.body.classList.add(CLASSNAMES_TO_ADD[theme])
  }, [theme])

  return (
    <SukiContext.Provider value={[theme, setTheme]}>
      {props.children}
    </SukiContext.Provider>
  )
}

export { SukiContext }

export default SukiProvider
